<script>
	import CertificationUploader from '@components/certifications/CertificationUploader.vue';
	import CertificationVersionHistory from '@components/certifications/CertificationVersionHistory.vue';
	import { mapActions, mapState } from 'vuex';

	export default {
		name: 'CertificationActionMenuHandlers',
		components: { CertificationVersionHistory, CertificationUploader },
		computed: {
			...mapState('certificationActions', [
				'isShowingVersionDialog',
				'isShowingDeleteCertDialog',
				'isShowingSendReminderDialog',
				'isSendingReminder',
				'isDeletingCertification',
				'selectedCert',
			]),
			versionDialogModel: {
				get() {
					return this.isShowingVersionDialog;
				},
				set(val) {
					this.cancelVersion()
				}
			},
			confirmReminderMessage() {
				if (!this.selectedCert) return '';
				return `Are you sure you want to send a reminder to ${this.selectedCert.employeeName} to upload their <strong>${this.selectedCert.name}</strong>?`;
			}
		},
		methods: {
			...mapActions('certificationActions', [
				'confirmDelete',
				'confirmReminder',
				'setProp',
				'cancelReminder',
				'cancelDelete',
				'cancelVersion'
			]),
		},
	};
</script>

<template>
	<div>
		<confirmation-dialog
			:dialog="isShowingDeleteCertDialog"
			text="Are you sure you want to delete this certification?"
			:isConfirming="isDeletingCertification"
			@onConfirm="confirmDelete"
			@onCancel="cancelDelete"
		/>

		<confirmation-dialog
			:dialog="isShowingSendReminderDialog"
			:text="confirmReminderMessage"
			:isConfirming="isSendingReminder" @onConfirm="confirmReminder" @onCancel="cancelReminder" />

		<v-dialog v-model="versionDialogModel" width="700" scrollable>
			<certification-version-history :certification="selectedCert" />
		</v-dialog>
	</div>
</template>

<style scoped>

</style>